import { render, staticRenderFns } from "./UiLayoutFooter.vue?vue&type=template&id=b9232188&scoped=true"
import script from "./UiLayoutFooter.vue?vue&type=script&lang=js"
export * from "./UiLayoutFooter.vue?vue&type=script&lang=js"
import style0 from "./UiLayoutFooter.vue?vue&type=style&index=0&id=b9232188&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9232188",
  null
  
)

export default component.exports